var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    {
      staticClass: "content",
      attrs: { "no-margin": "", "no-padding": "", stretch: "" },
    },
    [
      _c("app-default-settings", { attrs: { state: _vm.state } }),
      _c(
        "w-col",
        {
          staticClass: "blue-back",
          attrs: { xs: "12", md: "6", "no-margin": "", block: "" },
        },
        [
          _c(
            "w-row",
            { attrs: { block: "", stretch: "" } },
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("app-select-sale-layout", {
                    staticClass: "mtl",
                    attrs: {
                      id: "",
                      label: _vm.$ct("layout-select"),
                      fancy: "",
                      "sale-type-id": _vm.state.doc.SaleTypeID,
                      "add-default-option": "",
                    },
                    model: {
                      value: _vm.sale.LayoutID,
                      callback: function ($$v) {
                        _vm.$set(_vm.sale, "LayoutID", $$v)
                      },
                      expression: "sale.LayoutID",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("app-custom-language-select", {
                    staticClass: "mtl",
                    attrs: { label: _vm.$ct("language-select"), fancy: "" },
                    model: {
                      value: _vm.sale.Lng,
                      callback: function ($$v) {
                        _vm.$set(_vm.sale, "Lng", $$v)
                      },
                      expression: "sale.Lng",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("app-total-box", { attrs: { sale: _vm.sale } }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }